import { injectable } from 'tsyringe';
import { OWInternalSettings } from '../../odk-internal-ts/ow-internal-settings';

// -----------------------------------------------------------------------------
@injectable()
export class OWInternalSettingsWrapper {
  // ---------------------------------------------------------------------------
  public async getDisableInGameRecommendations(): Promise<boolean | undefined> {
    const response = await OWInternalSettings.get(
      overwolfInternal.settings.enums.SettingsCategory.Dynamic,
    );
    return response.setting?.disableInGameRecommendations;
  }

  // ---------------------------------------------------------------------------
  public async setDisableInGameRecommendations(value: boolean): Promise<void> {
    await OWInternalSettings.set(
      overwolfInternal.settings.enums.SettingsCategory.Dynamic,
      { disableInGameRecommendations: value },
    );
  }
}
